var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "coin",
      attrs: {
        width: "19",
        height: "21",
        viewBox: "0 0 19 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M0.450684 15.2707L8.65161 20.0781L15.7214 15.8363L18.5493 7.63534L15.7214 1.41395L12.6107 0L5.8237 0.565581L0.450684 7.35255V15.2707Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M6.69141 18.0989L13.1761 14.1398L16.004 6.78723L12.8933 0.848633",
          stroke: "black",
          "stroke-width": "1.24818"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M13.2075 13.9512L15.1561 15.2701",
          stroke: "black",
          "stroke-width": "1.24818"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M15.722 6.78748L17.7325 7.73084",
          stroke: "black",
          "stroke-width": "1.24818"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M5.19399 14.9778L2.94727 13.6603V7.8632L6.6918 3.12012H10.4363L11.6845 5.49166",
          stroke: "black",
          "stroke-width": "1.24818"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M14.459 10.5044L16.6775 11.5453",
          stroke: "black",
          "stroke-width": "1.24818"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M9.18777 16.5056L11.2834 17.7759",
          stroke: "black",
          "stroke-width": "1.24818"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M13.8694 2.80833L16.3657 4.0884",
          stroke: "black",
          "stroke-width": "1.24818"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }